/**
 * 路径处理器 - 优化重复的遍历逻辑
 */
import { Paths, MethodsType, GetSchema } from '@/define';
import { GetHelper } from '@/methods/get';
import { PostHelper } from '@/methods/post';
import { useGetMethdos } from '@/methods/get';
import { usePostMethdos } from '@/methods/post';
const clone = require('clone');

// 全局忽略 URL 列表
let globalIgnoreUrls: string[] = [];

/**
 * 设置全局忽略 URL 列表
 */
export function setIgnoreUrls(ignoreUrls: string[] = []) {
  globalIgnoreUrls = ignoreUrls;
}

/**
 * 检查 URL 是否应该被忽略
 */
function shouldIgnoreUrl(url: string): boolean {
  return globalIgnoreUrls.includes(url);
}

/**
 * 遍历所有路径和方法
 * @param paths - Swagger 的 paths 对象
 * @param callback - 处理每个路径方法的回调函数
 */
export const forEachPath = (
  paths: Paths,
  callback: (params: { uri: string; method: string; schema: GetSchema }) => void
): void => {
  Object.keys(paths).forEach((uri) => {
    // 检查是否在忽略名单中
    if (shouldIgnoreUrl(uri)) {
      console.log(`⚠️  跳过忽略的 URL: ${uri}`);
      return;
    }
    
    const pathItem: any = (paths as any)[uri];
    Object.keys(pathItem).forEach((method) => {
      callback({ uri, method, schema: clone(pathItem[method]) });
    });
  });
};

/**
 * 生成所有路径的 Helper 实例
 * @param paths - Swagger 的 paths 对象
 * @returns Helper 实例数组
 */
export const generateHelpers = (paths: Paths): Array<GetHelper | PostHelper> => {
  const helpers: Array<GetHelper | PostHelper> = [];
  
  forEachPath(paths, ({ uri, method, schema }) => {
    if (method === MethodsType.Get) {
      helpers.push(new GetHelper(uri, method as MethodsType, schema));
    } else {
      helpers.push(new PostHelper(uri, method as MethodsType, schema));
    }
  });
  
  return helpers;
};

/**
 * 生成所有路径的模板渲染器
 * @param paths - Swagger 的 paths 对象
 * @param renderCallback - 自定义渲染回调函数
 * @returns 渲染后的模板字符串数组
 */
export const generateTemplates = (paths: Paths, renderCallback?: Function): string[] => {
  const templates: string[] = [];
  
  forEachPath(paths, ({ uri, method, schema }) => {
    const schemaData: any = schema;
    const renderer = method === 'get'
      ? useGetMethdos(uri, method as MethodsType, schema, schemaData['responses'])
      : usePostMethdos(uri, method as MethodsType, schema);
    
    templates.push(renderer.renderTemplate(renderCallback));
  });
  
  return templates;
};

/**
 * 生成所有路径的 JsDoc 模板
 * @param paths - Swagger 的 paths 对象
 * @param renderJsDocCallback - 自定义 JsDoc 渲染回调函数
 * @returns 渲染后的 JsDoc 字符串数组
 */
export const generateJsDocTemplates = (paths: Paths, renderJsDocCallback?: Function): string[] => {
  const templates: string[] = [];
  
  forEachPath(paths, ({ uri, method, schema }) => {
    const schemaData: any = schema;
    const renderer = method === 'get'
      ? useGetMethdos(uri, method as MethodsType, schema, schemaData['responses'])
      : usePostMethdos(uri, method as MethodsType, schema);
    
    templates.push(renderer.renderJsDocTemplate(renderJsDocCallback));
  });
  
  return templates;
};

